export enum EmailTypes {
    aboutOsasEmailToPatient = 'aboutOsasEmailToPatient',
    accountDeactivationByOrganization = 'accountDeactivationByOrganization',
    accountRequestApprovalByKsyos = 'accountRequestApprovalByKsyos',
    accountRequestApprovalByOrganization = 'accountRequestApprovalByOrganization',
    accountRequestApprovedByOrganization = 'accountRequestApprovedByOrganization',
    accountRequestRejectedByOrganization = 'accountRequestRejectedByOrganization',
    addedAddendumToDiagnosticReport = 'addedAddendumToDiagnosticReport',
    carePathInformationRequest = 'carePathInformationRequest',
    carePathInformationRequestKsyos = 'carePathInformationRequestKsyos',
    closedWatchpatExamination = 'closedWatchpatExamination',
    dermaSnelDelayedToGP = 'dermaSnelDelayedToGP',
    dermaSnelFirstToRecipientPractitioner = 'dermaSnelFirstToRecipientPractitioner',
    dermaSnelOverdueToGP = 'dermaSnelOverdueToGP',
    dermaSnelOverdueToRecipientPractitioner = 'dermaSnelOverdueToRecipientPractitioner',
    dermaSnelOverdueToSupport = 'dermaSnelOverdueToSupport',
    dermaSnelSecondToRecipientPractitioner = 'dermaSnelSecondToRecipientPractitioner',
    dermaSnelThirdToRecipientPractitioner = 'dermaSnelThirdToRecipientPractitioner',
    ectosenseExaminationCompleted = 'ectosenseExaminationCompleted',
    ectosenseExaminationFailed = 'ectosenseExaminationFailed',
    existingPractitionerAddedToOrganization = 'existingPractitionerAddedToOrganization',
    feedbackExportEmail = 'feedbackExportEmail',
    financialExportSensitiveDataAccessed = 'financialExportSensitiveDataAccessed',
    fysiologicNoDiary = 'fysiologicNoDiary',
    ggzQuestionnaireReminder = 'ggzQuestionnaireReminder',
    holterReadOutPendingUploadReminder = 'holterReadOutPendingUploadReminder',
    homeExaminationConfirmation = 'homeExaminationConfirmation',
    inactiveAccountsEmail = 'inactiveAccountsEmail',
    inactivity = 'inactivity',
    inviteToMijnKsyosDermaOth = 'inviteToMijnKsyosDermaOth',
    inviteToMijnKsyosDermaOthAltoFlow = 'inviteToMijnKsyosDermaOthAltoFlow',
    inviteToMijnKsyosGHC = 'inviteToMijnKsyosGHC',
    inviteToMijnKsyosOphthalmology = 'inviteToMijnKsyosOphthalmology',
    inviteToMijnKsyosOsaso = 'inviteToMijnKsyosOsaso',
    inviteToMijnKsyosOsasvo = 'inviteToMijnKsyosOsasvo',
    mraReferralLetterToPatient = 'mraReferralLetterToPatient',
    mraReferralLetterToPoli = 'mraReferralLetterToPoli',
    newActivityForRecipientPractitioner = 'newActivityForRecipientPractitioner',
    newAddendumOsasc1Notification = 'newAddendumOsasc1Notification',
    newAddendumSomnologyNotification = 'newAddendumSomnologyNotification',
    newContactToServiceConsumerOrganization = 'newContactToServiceConsumerOrganization',
    newDiagnosticReportToRequesterPractitioner = 'newDiagnosticReportToRequesterPractitioner',
    newDiagnosticReportToServiceConsumerSupervisor = 'newDiagnosticReportToServiceConsumerSupervisor',
    newNoShowsUploaded = 'newNoShowsUploaded',
    newPatientDataRequest = 'newPatientDataRequest',
    newReportClarificationReceived = 'newReportClarificationReceived',
    newReportClarificationRequested = 'newReportClarificationRequested',
    newRequestToRecipientPractitioner = 'newRequestToRecipientPractitioner',
    newSupervisionForReport = 'newSupervisionForReport',
    newUzovisRecord = 'newUzovisRecord',
    noGradersAvailable = 'noGradersAvailable',
    noProcessActivityGradersAvailable = 'noProcessActivityGradersAvailable',
    orderSuppliesOrderCreatedCustomer = 'orderSuppliesOrderCreatedCustomer',
    orderSuppliesOrderCreatedSupport = 'orderSuppliesOrderCreatedSupport',
    organizationChangeName = 'organizationChangeName',
    organizationPatientCountsUpdated = 'organizationPatientCountsUpdated',
    osasAbortedProcesses = 'osasAbortedProcesses',
    osasAbortedProcesses120days = 'osasAbortedProcesses120days',
    osasInviteToMijnKsyos = 'osasInviteToMijnKsyos',
    osasNoTreatment = 'osasNoTreatment',
    osasPatientFirstReminder = 'osasPatientFirstReminder',
    osasPatientMraReferralLetterToPatient = 'osasPatientMraReferralLetterToPatient',
    osasPatientSecondReminder = 'osasPatientSecondReminder',
    osasPatientSptOrCpapMail = 'osasPatientSptOrCpapMail',
    osasPatientThirdReminder = 'osasPatientThirdReminder',
    osasProcedureWithoutQuestionnairesFilledIn = 'osasProcedureWithoutQuestionnairesFilledIn',
    osasqRepeatedQuestionnaireEmail = 'osasqRepeatedQuestionnaireEmail',
    osasRequestedWatchpatExamination = 'osasRequestedWatchpatExamination',
    osasResendMijnKsyosQuestionnaires = 'osasResendMijnKsyosQuestionnaires',
    patientAccessLimitIsExceededForAllToPrivacyManager = 'patientAccessLimitIsExceededForAllToPrivacyManager',
    patientAccessLimitIsExceededForOneToPrivacyManager = 'patientAccessLimitIsExceededForOneToPrivacyManager',
    patientAccessLimitIsExceededToManager = 'patientAccessLimitIsExceededToManager',
    patientFeedbackInvite = 'patientFeedbackInvite',
    patientOphthalmologyResultsAvailable = 'patientOphthalmologyResultsAvailable',
    patientRecipe = 'patientRecipe',
    patientSatisfactionQuestionnaire = 'patientSatisfactionQuestionnaire',
    patientWasNotCreatedInCloudpat = 'patientWasNotCreatedInCloudpat',
    patientWasNotCreatedInCloudpatOsas = 'patientWasNotCreatedInCloudpatOsas',
    payoutsEmail = 'payoutsEmail',
    practitionerActivationEmail = 'practitionerActivationEmail',
    practitionerActivationReminderEmail = 'practitionerActivationReminderEmail',
    practitionerChangeEmploymentTaxesDetailsEmail = 'practitionerChangeEmploymentTaxesDetailsEmail',
    practitionerMultipleUsernamesReminderEmail = 'practitionerMultipleUsernamesReminderEmail',
    practitionerOnboardingEmail = 'practitionerOnboardingEmail',
    practitionerResetMfaEmail = 'practitionerResetMfaEmail',
    practitionerResetPasswordEmail = 'practitionerResetPasswordEmail',
    practitionerSetHardwareTokenEmail = 'practitionerSetHardwareTokenEmail',
    practitionerUsernameReminderEmail = 'practitionerUsernameReminderEmail',
    procedureNeedsAnalysis = 'procedureNeedsAnalysis',
    procedureNeedsGrading = 'procedureNeedsGrading',
    processActivityResultForRequesterPractitioner = 'processActivityResultForRequesterPractitioner',
    processAssessmentCompleted = 'processAssessmentCompleted',
    processConsultAnswered = 'processConsultAnswered',
    processExaminationRequest = 'processExaminationRequest',
    processExternalReferralRequest = 'processExternalReferralRequest',
    processNeedsGrading = 'processNeedsGrading',
    referralAccepted = 'referralAccepted',
    referralInformationToPatientKsyosMedicalCenter = 'referralInformationToPatientKsyosMedicalCenter',
    referralInformationToPatientNsi = 'referralInformationToPatientNsi',
    referralNotificationToRecipientOrganization = 'referralNotificationToRecipientOrganization',
    referralRejected = 'referralRejected',
    reminderCloseAnsweredConsults = 'reminderCloseAnsweredConsults',
    reminderProcedureNeedsGrading = 'reminderProcedureNeedsGrading',
    reminderProcessNeedsGrading = 'reminderProcessNeedsGrading',
    reminderRequestToRecipientPractitioner = 'reminderRequestToRecipientPractitioner',
    requestBankAccountDetailsChangeNotification = 'requestBankAccountDetailsChangeNotification',
    requestedWatchpatExamination = 'requestedWatchpatExamination',
    requestMessageSend = 'requestMessageSend',
    respiAllerCloseInactiveProcess = 'respiAllerCloseInactiveProcess',
    respiAllerGradingCompleted = 'respiAllerGradingCompleted',
    sendEvidencioQuestionnaire = 'sendEvidencioQuestionnaire',
    sendEvidencioQuestionnaireOpenDraftReminder = 'sendEvidencioQuestionnaireOpenDraftReminder',
    sendEvidencioQuestionnaireReminder = 'sendEvidencioQuestionnaireReminder',
    sendFundingReprocessMail = 'sendFundingReprocessMail',
    stalledEctosenseActivity = 'stalledEctosenseActivity',
    stalledEctosenseActivityToPatient = 'stalledEctosenseActivityToPatient',
    supervisionResults = 'supervisionResults',
    supportDeskInvalidRequestProvider = 'supportDeskInvalidRequestProvider',
    tcohPendingUploadReminder = 'tcohPendingUploadReminder',
    teleDiaRequestWithAdminStatus = 'teleDiaRequestWithAdminStatus',
    uploadRecordingsToAnalysisPartyFailed = 'uploadRecordingsToAnalysisPartyFailed',
    zorgMailRecipientNotFound = 'zorgMailRecipientNotFound',
}
